export default "__VITE_ASSET__ClN7HX9$__"